import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static targets = ["QuantityInput", "ListingSelect"]

  onListingChange(e) {
    const selectedOption = e.currentTarget.options[e.currentTarget.selectedIndex]
    const listingMinimumQuantity = selectedOption.dataset.minimumQuantity
    const quantityInput = this.QuantityInputTargets.find(input => input.dataset.orderItemId == e.currentTarget.dataset.orderItemId)
    const quantityValue = quantityInput.value
    const select2Container = Array.from(e.currentTarget.parentNode.children).find((elem) => elem.classList.contains('select2-container'))

    if (parseInt(quantityValue) < parseInt(listingMinimumQuantity)) {
      if (select2Container) {
        select2Container.querySelector('.select2-selection').classList.add('!border-red-500')
      }
      const errorDiv = document.createElement('div')
      errorDiv.id = `listing-${e.currentTarget.dataset.orderItemId}-error`
      errorDiv.classList.add('text-red-500', 'text-xs', 'mt-1')
      errorDiv.innerText = `Minimum quantity is ${listingMinimumQuantity}`
      e.currentTarget.parentElement.appendChild(errorDiv)
    } else {
      const errorDiv = document.getElementById(`listing-${e.currentTarget.dataset.orderItemId}-error`)

      if (errorDiv) {
        errorDiv.remove()
      }

      if (select2Container) {
        select2Container.querySelector('.select2-selection').classList.remove('!border-red-500')
      }
    }
  }

}